module.exports = __webpack_public_path__ + "static/media/interacao.6161ff40.png";